import ApiService from "../../commons/services/ApiService";
import CompanyAPI from "../company/CompanyAPI";

const apiService = new ApiService();
const companyAPI = new CompanyAPI();

export default class HallPointsAPI {

    URI_V1 = "/v1/hall-points"

    create = async (data: any) => {
        return await apiService.post(`${this.URI_V1}`, data);
    };

    update = async (id: any, data: any) => {
        return await apiService.put(`${this.URI_V1}/${id}`, data);
    };

    fidnAllConfig = async () => {
        return await apiService.get(`${this.URI_V1}/company/${companyAPI.getCompanyManagment().id}`);
    };

    delete = async (id:any) => {
        return await apiService.delete(`${this.URI_V1}/${id}`);
    };

    findById = async (id:any) => {
        return await apiService.get(`${this.URI_V1}/${id}`);
    };

    fidnAllServices = async () => {
        return await apiService.get(`${this.URI_V1}/services?companyId=${companyAPI.getCompanyManagment().id}`);
    };

    createRewards = async (data: any) => {
        return await apiService.post(`${this.URI_V1}/rewards?companyId=${companyAPI.getCompanyManagment().id}`, data);
    };

    getRewards = async () => {
        return await apiService.get(`${this.URI_V1}/rewards?companyId=${companyAPI.getCompanyManagment().id}`);
    };

    deleteRewards = async (id: any) => {
        return await apiService.delete(`${this.URI_V1}/rewards/${id}?companyId=${companyAPI.getCompanyManagment().id}`);
    };


}
